import { Dialog } from "@omnia/shared/shell/dialog";
import { defineDirective, handleApiError, IOmniaShell } from "../../omnia"
import { IFieldsService, INutritionService } from "../../types"
import { getResetCroppingVm, ResetCroppingVm } from "./reset-cropping"

export class ResetDlg extends Dialog {

    static create() {
        return defineDirective(ResetDlg, "app/nutrition/requirements/reset/reset.html");
    }

    public crops: ResetCroppingVm[];

    public resetRequirements: boolean;
    public resetBalances: boolean;

    static $inject = [
        "$scope",
        "OmniaNutritionService",
        "OmniaFieldsService",
        "OmniaShell"];

    constructor(
        $scope: ng.IScope,
        private svc: INutritionService,
        private fieldSvc: IFieldsService,
        shell: IOmniaShell) {

        super($scope, shell);

    }

    $onInit() {

        let ids = <number[]>this.arguments;

        this.crops = ids
            .map(id => this.fieldSvc.findCropping(id))
            .filter(c => c && c.authorized)
            .map(c => getResetCroppingVm(c, this.svc.isCroppingInNutritionPlans(c.croppingId)));

    }

    hasCropsInPlans(): boolean {
        return this.crops.some(c => c.inNutritionPlans);
    }

    canCommit(): boolean {

        if (this.resetRequirements && (!this.resetBalances)) {
            if (this.crops.every(c => c.inNutritionPlans)) return false;
        }

        return this.resetRequirements || this.resetBalances;
    }

    commit() {

        if (!this.canCommit()) {
            return;
        }

        let ids = this.crops.map(c => c.croppingId);

        this.svc.resetRequirements(ids, this.resetRequirements, this.resetBalances)
            .then(() => this.close(1))
            .catch(r => handleApiError(this.shell, r, { defaultMessage: "An error has occurred while resetting the requirements" }))

    }
}
